<!--
 * @Author: qinzhenpen qzp1807@126.com
 * @Date: 2023-09-28 14:48:29
 * @LastEditors: qinzhenpen qzp1807@126.com
 * @LastEditTime: 2025-03-29 13:24:49
 * @FilePath: \tianze_web\src\components\Advertisement\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!-- 广告位信息 -->
<template>
  <div>

  </div>
</template>

<script>
import jQuery from 'jquery';
export default {
  name: 'Advertisement',
  props: {
    height: {
      type: String,
      required: false,
      default: '600px'
    }
  },
  data() {
    return {
      advList: []
    }
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    getInfo(){
      //获取头部
      if(!this.$isEmpty(this.$ls.get(this.$getKeyInfo("advTime")))){
        console.log("距上次推广位展示时间没有超过一小时");
        return;
      }
      this.$get("/api/studentClientLink/getList.do",{studentClientLinkType:"ADV",studentClientLinkStatus:1}).then((ret)=>{
        if(ret.code == 0){
          if(!this.$isEmpty(ret.data)){ //拼接HTML
            // this.$ls.set(this.$getKeyInfo("advTime"),"show"); //暂时设置一小时显示一次
            // let htm = "<div id='ADVInfo' style='max-height: 520px;overflow-y: auto;-ms-overflow-style: none;'>";
            // for(let i = 0;i<ret.data.length;i++){
            //   htm += "<a href='"+ret.data[i].studentClientLinkContent+"' target='_blank'><img style='width:160px;height:80px' src="+this.$isHttp(ret.data[i].studentClientLinkImg)+"></img><a>"
            // }
            // htm += "</div>";
            // this.$notify({
            //   title: '推广位',
            //   duration: 0,
            //   offset: '10%',
            //   dangerouslyUseHTMLString: true,
            //   message: htm
            // });
            // jQuery(".el-notification").css("top",((jQuery("#app").height() - jQuery(".el-notification").height()) / 2)+'px').css("width","210px")
            // jQuery("#ADVInfo").parents(".el-notification").css("border","1px solid #c2c4ca")
          }
        }
      });
    },
  }
}
</script>

<style scoped>
  #ADVInfo{
    /deep/ .el-notification{
      width: 210px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Advertisement/index.vue